import { Fragment } from "react";
import { InView }   from "react-intersection-observer";
import { Waypoint } from "react-waypoint";
import EmptyFeed    from "../../notificationFeedEmptyView";
import FeedItem     from "../notificationFeedItem";
import useStyles    from "./styles";

const Component = props => {
	const {
		feedData,
		handleFeedItem,
		isDepleted,
		isFetching,
		fetchMoreData,
		handleNotificationClick,
		activeTab,
		handleNotificationImpression
	 } = props;

	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<>
			{
				feedData.length ? (
					<div className = { classes.feedWrapper }>
						{feedData?.map ( ( feedItem, index ) => {
							return (
								<Fragment key = { index }>
									<InView as = "div"
										onChange = {
											inView => {
												if ( inView ) {
													return handleNotificationImpression ( feedItem );
												} else {
													return null;
												}
											}
										}
										threshold = { 0.7 }
									>
										<FeedItem
											feedItem                = { feedItem }
											handleFeedItem          = { handleFeedItem }
											handleNotificationClick = { data => handleNotificationClick ( { data, type: "activity" } ) }
										/>
									</InView>

									{ !isDepleted && !isFetching && feedData.length > 0 && index === feedData.length - 4 && (
										<Waypoint
											onEnter = { () => fetchMoreData () }
										/>
									)}
								</Fragment>
							);
						} )}
					</div>
				) : (
					<div className = { classes.feedWrapper }>
						<EmptyFeed activeTab = { activeTab } />
					</div>
				)
			}
		</>
	);
};

export default Component;